import {Popup} from '@/library/popup';
import {errorHandler} from '@/utils/portuna';
import axios from 'axios';
import AppPopupContact from '../../components/AppPopupContact.vue';
import store from '../../store';

function contactUser(id: number | number[], type: string = 'user', subject: string = '', message: string = '')
{
    axios.get('/ajax/contact-form/type/' + type).then(({data: {data}}) =>
    {
        let popup = new Popup({
            component: AppPopupContact,
            title: 'Nachricht verfassen',
            size: 'medium',
            form: true,
            componentProps: {
                type,
                id,
                recipients: data.recipients,
                prefillMessage: message,
                prefillSubject: subject,
            },
        });

        popup.open().then(() =>
        {
            store.dispatch('form/setFilter', data.filter).catch(console.error);
        });
    }).catch(errorHandler);
}

export {
    contactUser,
};